module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_kimono@2x-be43847260265644c869e0ce9f0aad32.webp";